const SESSION_TOKEN = 'token';
const THEME = 'theme';

export default {
  name: 'Store',

  saveToken(token) {
    localStorage.setItem(SESSION_TOKEN, token);
  },

  getToken() {
    return localStorage.getItem(SESSION_TOKEN);
  },

  clearToken() {
    localStorage.removeItem(SESSION_TOKEN);
  },

  saveTheme(theme) {
    sessionStorage.setItem(THEME, theme || '');
  },
  getTheme() {
    return sessionStorage.getItem(THEME);
  },
};
